/* eslint-disable */
// @ts-ignore
// @ts-nocheck
import React from "react";
import { Tabs } from "@carbon/react";

export default (props) => {
  return <Tabs {...props} />;
};
